import { InjectionToken } from '@angular/core';

export const LICENSE_AGREEMENT_LOCALIZATION_SCOPE = 'license-agreement';
export const LICENSE_AGREEMENT_PAGE_ROUTE = 'license-agreement';
export const LICENSE_AGREEMENT_PREFERENCE_SECTION = new InjectionToken<string>('License agreement section');
